import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import Dashboard from "./pages/Dashboard";
import TransactionTable from "./pages/TransactionTable";
import Form from "./pages/Form";
import Photo from "./pages/Photo";
import ImageUploader from "./pages/ImageUploader";
// import DrawableCanvas from "./components/DrawableCanvas";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Layout wrapper for main pages */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="image-generator" element={<ImageUploader />} />
          <Route path="photo" element={<Photo />} />
          {/* <Route path="drawable-canvas" element={<DrawableCanvas />} /> */}
          <Route path="about" element={<Form />} />
          <Route path="contact" element={<TransactionTable />} />
        </Route>
        {/* Other routes without Layout */}
        {/* <Route path="/login" element={<Login />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
